import {WinPresentationController} from "../WinPresentationController";
import {RockBottom} from "../../RockBottom";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {RockBottomGameConfig} from "../../RockBottomGameConfig";
import {DrinkAnimView} from "../../view/DrinkAnimView";
import {gsap} from "gsap";

export class DrinkController extends WinPresentationController {
    private _view: DrinkAnimView;

    constructor() {
        super("DrinkController", true);
        this._view = new DrinkAnimView();
    }

    protected hasWin(): boolean {
        //in case it's not in bonus game (FS or SFS)
        if (!(RockBottom.inBonusGame)) {
            return false;
        }

        //below code will run in Bonus Game (FS or SFS) only
        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData();

        return parsedData.fsLevel < parsedData.fsLevelNextSpin;
    }

    protected createWinAnimation(): Promise<any> {
        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData(),
            indexToSelect: number = (RockBottomGameConfig.MID_SYMS.length - 1) - parsedData.fsLevel,
            animName: string = RockBottomGameConfig.MID_SYMS[indexToSelect],
            tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this._view.playDrinkAnimation(animName));
        tl.to(this, {duration: 0.1});

        return Promise.resolve(tl);
    }

    protected skip(): void {

    }
}